import request from '@/utils/request'

export function getCheckinConfig() {
  return request({
    url: '/biz/giftcard/checkin-config/get',
    method: 'get'
  })
}

export function saveCheckinConfig(data) {
  return request({
    url: '/biz/giftcard/checkin-config/save',
    method: 'post',
    data
  })
}
